export const AbGoals = {
    MadeItToSignIn: 'AbGoalConfigs.Booking.MadeItToSignIn',
    CreatedStrongPassword: 'AbGoalConfigs.PatientSignUp.CreatedStrongPassword',
    MadeItToStart: 'AbGoalConfigs.Booking.MadeItToStart',
    MadeItToCreateAccount: 'AbGoalConfigs.Booking.MadeItToCreateAccount',
    MadeItToPatientSelect: 'AbGoalConfigs.Booking.MadeItToPatientSelect',
    MadeItToPhone: 'AbGoalConfigs.Booking.MadeItToPhone',
    MadeItToReview: 'AbGoalConfigs.Booking.MadeItToReview',
    MadeItToSync: 'AbGoalConfigs.Booking.MadeItToSync',
    MadeItToComplete: 'AbGoalConfigs.Booking.MadeItToComplete',
    MadeItToVerify: 'AbGoalConfigs.Booking.MadeItToVerify',
    MadeItToPin: 'AbGoalConfigs.Booking.MadeItToPin',
    ClickedBook: 'AbGoalConfigs.Booking.ClickedBook',
};

export const OptimizelyAbMetrics = {
    ClickedDownloadTheApp: 'ClickedDownloadTheApp',
    MadeItToReviewAndBook: 'MadeItToReviewAndBook',
    MadeItToBookingComplete: 'MadeItToBookingComplete',
    WellnessGuideBookingButtonClicked: 'WellnessGuideBookingButtonClicked',
    BookingCompleteCheckInClicked: 'BookingCompleteCheckInClicked',
    BookingCompleteWellnessBookingButtonClicked:
        'BookingCompleteWellnessBookingButtonClicked',
};
